module.exports = __webpack_public_path__ + "static/img/2_bc_tilting-i.ed9b3e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2_bc_tilting-i.png
// module id = NI34
// module chunks = 0